import React from "react";
import CustomDataGrid from "./../../components/CustomDataGrid/CustomDataGrid.tsx";
import SideBar from "./../../layouts/sidebar/SideBar.tsx";
import Leo from "./../../../assets/images/Leo.png";
import { Button, Grid } from "@mui/material";
import searchIcon from "./../../../assets/icons/search.ico";
import bin from "./../../../assets/icons/reject.png";
import edit from "./../../../assets/icons/edit.png";
import approveImg from "./../../../assets/icons/checked.png";
import linkactiveImg from "./../../../assets/images/linkActive.png";
import linkDeactiveImg from "./../../../assets/images/linkDective.png";
import AutoCompleteMultiSelect from "./../..//components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import "./KYCFormRequest.css";
// import RestaurantDetailsDialog from './RestaurantDetailsDialog/RestaurantDetailsDialog.tsx';
import CancelReasonDialog from "./../NewRestaurantRequest/CancelReasonDialog/CancelReasonDialog.tsx";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import KycDetails from "./KycDetails/KycDetails.tsx";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import LoadingView from "../../components/LoadingView/LoadingView.js";
import TopHeader from "../../../components/TopHeader.tsx";

function KYCFormRequest(props) {
  const columnsdatas = [
    {
      field: "id",
      headerName: "Application Id",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "name",
      headerName: "Restaurant Name",
      renderCell: (params) => (
        <div>
          <span
            onClick={() => {
              openDetailsModal(params.row.id);
            }}
            style={{ color: "blue", cursor: "pointer" }}
          >
            {params.value}
          </span>
        </div>
      ),
      align: "center",
      headerAlign: "center",
      flex: 1,
    },

    // {
    //     field: 'number', headerName: 'Contact Number', align: 'center', headerAlign: 'center', flex: 1
    // },
    {
      field: "city",
      headerName: "Address",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "companyRegistrationNumber",
      headerName: "Company Number",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "creationDate",
      headerName: "Request Date",
      align: "center",
      renderCell: (params) => <div>{dateFormated(params.value)}</div>,
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "approvalStatusDescription",
      headerName: "Status",
      renderCell: (params) => (
        // <div className={`${params.value === "Approved" ? "approve" : params.value === "Pending" ? "pending" : "reject"} RoundedStatus`}>
        //     {params.value}
        // </div>, align: 'center', headerAlign: 'center', flex: 1
        <div
          className={`${
            params.value === "Approved"
              ? "approve"
              : params.value === "Pending"
              ? "pending"
              : params.value === "Link Activated"
              ? "approve"
              : "reject"
          } RoundedStatus`}
        >
          {params.value}
        </div>
      ),
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
  ];
  const dateFormated = (props) => {
    var d = new Date(props);
    return d.toDateString();
  };

  const [selectedData, setSelectedData] = React.useState([]);
  const [enableOptions, setEnableOptions] = React.useState(false);
  const getselectedData = (props) => {
    console.log("props: " + props);

    var temp = props;
    setSelectedData(temp);
    if (props.length > 0) {
      setEnableOptions(true);
    } else {
      setEnableOptions(false);
    }
  };

  const [selectedDataForDetails, setselectedDataForDetails] =
    React.useState(false);
  const openDetailsModal = (props) => {
    console.log("props: " + props);
    setopenDetails(true);
    setselectedDataForDetails(props);
  };

  const [open, setOpen] = React.useState(false);
  const [clickedRestaurant, setClickedRestaurant] = React.useState("");
  const handleClickOpen = (props) => {
    setOpen(true);
    setClickedRestaurant(props);
  };
  const handleAddItem = (AddItemData) => {
    setOpen(AddItemData);
  };

  const [openDetails, setopenDetails] = React.useState(false);

  const [openCancelReasonDialog, setopenCancelReasonDialog] =
    React.useState(false);
  const [clickedRestaurantDetails, setClickedRestaurantDetails] =
    React.useState([]);
  const handleClickopenCancelReasonDialog = () => {
    setopenCancelReasonDialog(true);
    var tempData = [];
    var allTempData = [];
    selectedData.map((data, index) => {
      var dt = dataRows.find((x) => x.id === data);
      var obj = {
        id: dt.id,
        title: dt.name,
      };
      tempData.push(obj);
    });
    dataRows.map((dt, index) => {
      var obj = {
        id: dt.id,
        title: dt.name,
      };
      allTempData.push(obj);
    });
    setAllRestaurantDetails(allTempData);
    setClickedRestaurantDetails(tempData);
  };
  const handleAddopenCancelReasonDialog = (AddItemData) => {
    setopenCancelReasonDialog(AddItemData);
    loadData();
  };

  const handlecloseKycDetails = () => {
    setopenDetails(false);
    loadData();
  };

  const apiAddress = process.env.REACT_APP_SECRET;

  React.useEffect(() => {
    loadData();
  }, []);

  const [dataRows, setDataRows] = React.useState([]);
  const [datas, setDatas] = React.useState([]);
  const loadData = async () => {
    await axios
      .get(apiAddress + "/api/KYCForm/getKycRequest")
      .then((response) => {
        console.log(
          "response.data.companyDetail: " + response.data.companyDetail
        );
        setDataRows(response.data.companyDetail);
        var tempData = [];
        tempData.push(response.data.companyDetail);
        tempData.push(response.data.paymentAcceptanceDetails);
        tempData.push(response.data.personelLists);
        tempData.push(response.data.principleContacts);
        setDatas(response.data);
        console.log(response.data);
      });
  };

  const approvedData = async (props) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <h1>Are you sure?</h1>
            <p>You want to approve this?</p>
            <button onClick={onClose} className="btn-no btn-common">
              No
            </button>
            <button
              className="btn-yes btn-common"
              onClick={() => {
                // this.handleClickDelete();
                approve(props);
                onClose();
              }}
            >
              Yes
            </button>
          </div>
        );
      },
    });
  };

  const activeLinkData = async (props, text) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <h1>Are you sure?</h1>
            <p>{text}</p>
            <button onClick={onClose} className="btn-no btn-common">
              No
            </button>
            <button
              className="btn-yes btn-common"
              onClick={() => {
                // this.handleClickDelete();
                approve(props);
                onClose();
              }}
            >
              Yes
            </button>
          </div>
        );
      },
    });
  };

  const approve = async (props) => {
    SetloadingModal(true);
    axios({
      method: "put",
      url: apiAddress + "/api/KYCForm/updateKycRequests/" + props,
      data: selectedData,
    })
      .then(function (response) {
        SetloadingModal(false);
        console.log(response);
        toast.success("Successfully Saved", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        loadData();
      })
      .catch(function (error) {
        SetloadingModal(false);
        console.log(error);
        toast.error("Error" + error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };
  const [allRestaurantDetails, setAllRestaurantDetails] = React.useState([]);

  const [loadingModal, SetloadingModal] = React.useState(false);

  const closeLoadingModal = () => {
    SetloadingModal(false);
  };

  return (
    <div>
      <LoadingView open={loadingModal} close={closeLoadingModal} />
      <ToastContainer />
      <div>
        {/* <div className=' d-flex justify-content-between' style={{ height: '3.5rem', backgroundColor: '#56595b' }}>
                    <div className='' >
                        <div className='d-flex flex-row'>
                            <div>

                                <SideBar />

                            </div>
                            <h4 className='mt-1' style={{ color: 'white', marginLeft: '1rem' }}>Go <span style={{ color: '#e5e5e5', fontWeight: '700' }}>Taste</span></h4>



                        </div>
                    </div>
                    <div className='d-flex' style={{ marginRight: '1rem', marginTop: '10px', gap: "10px" }}>
                        <h5 style={{ color: 'white', marginRight: '1rem' }}>Welcome, Leo</h5>
                        <img src={Leo} alt='leo' style={{ width: '2rem', height: '2rem' }} />
                        <h5 style={{ color: 'white', marginRight: '1rem', cursor: "pointer" }} onClick={() => {
                            localStorage.removeItem('gotasteadmintoken');
                            window.location.href = `/`;
                        }}>Log Out</h5>
                    </div>


                </div> */}
        <TopHeader />
        <div className="p-5">
          <div className="d-flex justify-content-center">
            <h3>KYC Requests</h3>
          </div>
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            mt={2}
            mb={2}
          >
            <Grid item>
              <Grid container spacing={2} alignItems="center">
                {/* <Grid item>
                                <div className={` ${enableOptions ? "" : "disable"}  roundedCorner`}>
                                    <img src={edit} alt="" style={{ width: '1rem' }} /> Edit
                                </div>
                            </Grid> */}
                <Grid item>
                  <div
                    className={` ${
                      enableOptions ? "" : "disable"
                    }  roundedCorner`}
                    onClick={() => {
                      approvedData(1);
                    }}
                  >
                    <img src={approveImg} alt="" style={{ width: "1rem" }} />{" "}
                    Approve
                  </div>
                </Grid>
                <Grid item>
                  <div
                    className={` ${
                      enableOptions ? "" : "disable"
                    }  roundedCorner`}
                    onClick={() => {
                      handleClickopenCancelReasonDialog();
                    }}
                  >
                    <img src={bin} alt="" style={{ width: "1rem" }} /> Reject
                  </div>
                </Grid>

                <Grid item>
                  <div
                    className={` ${
                      enableOptions ? "" : "disable"
                    }  roundedCorner`}
                    onClick={() => {
                      activeLinkData(6, "You want to deactive this?");
                    }}
                  >
                    <img
                      src={linkDeactiveImg}
                      alt=""
                      style={{ width: "1rem" }}
                    />{" "}
                    Canceled KYC
                  </div>
                </Grid>
                {/* <Grid item>
                                
                                <select className="form-select form-control" aria-label="Default select example">
                                    <option selected>Action</option>
                                    <option value="1">View</option>
                                    <option value="2">Two</option>
                                    <option value="3">Three</option>
                                </select>
                            </Grid> */}
              </Grid>
            </Grid>
            <Grid item>
              <Grid container flexDirection={"column"} alignItems={"center"}>
                <Grid item>
                  <img src={searchIcon} alt="" style={{ width: "1rem" }} />
                </Grid>
                <Grid item>Search</Grid>
              </Grid>
            </Grid>
          </Grid>
          {dataRows.length > 0 ? (
            <CustomDataGrid
              columns={columnsdatas}
              dataRows={dataRows}
              getselectedData={getselectedData}
              selectedRows={selectedData}
            />
          ) : (
            "Nothing found"
          )}
        </div>
        {/* <RestaurantDetailsDialog open={open}
                    onClose={handleAddItem} dialogName={"Add On"} restaurantName={clickedRestaurant} /> */}
        <CancelReasonDialog
          open={openCancelReasonDialog}
          onClose={handleAddopenCancelReasonDialog}
          dialogName={"Add On"}
          restaurantName={clickedRestaurantDetails}
          allRestaurant={allRestaurantDetails}
          from={2}
        />
        <KycDetails
          open={openDetails}
          onClose={handlecloseKycDetails}
          dialogName={"Add On"}
          data={datas}
          selectedData={selectedDataForDetails}
          key={selectedDataForDetails}
        />
      </div>
    </div>
  );
}

export default KYCFormRequest;
